import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaEye } from "react-icons/fa";
import { getCMSlist } from '../../actions/users';
import moment from 'moment';

const CmsList = () => {

   
    const navigate = useNavigate();

   
    const [cmsList, setCmsList] = useState([]);
    const [searchText, setSearchText] = useState("");

    function editR(id) {
        // alert(e.target.id);
        if (id != '') {
            navigate("/cmsedit/" + id);
        }

    }

    const getFaqList = async () => {
        var test = await getCMSlist({searchText});

        if (test && test.userValue) {
            setCmsList(test.userValue);
        }
    }

    useEffect(() => {
        getFaqList();
    }, [searchText]);

    const columns = [

        {

            key: "Question",
            name: "Question",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p>{row?.question}</p>
            ),
        },
        {

            key: "Answer",
            name: "Answer",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) =>(
                <p><div dangerouslySetInnerHTML={{__html:row?.answer}}></div></p>
            ),

        },         
        // {

        //     key: "Date",
        //     name: "Date",
        //     // // className: "tokenId",
        //     align: "left",
        //     sortable: false,
        //     cell: (row, index, column, id) =>(
        //         <p>{moment(row.date).format('MMMM,Do YYYY, hh:mm A')}</p>
        //     ),

        // },         
        {

            key: "Action",
            name: "Action",
            // className: "tokenQuantity",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                const checkin = row.status;
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-primary btn-sm"
                              onClick={() => editR(row._id)}

                            style={{ marginRight: '5px' }}
                        >
                            <FaEye />
                        </button>
                    </Fragment>
                );
            }

        },
    ];

    return (
        <Layout>
            <div className="cmslist">
                <h1 className="pagehead">CMS List</h1>
                <div className="cardbox">
                    <div className="tablebox">
                        <Form.Control type="text" onChange={(e)=>setSearchText(e?.target?.value)} value={searchText} placeholder="Filter with Question" />
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={cmsList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CmsList;